import {
  INCOME_TAX,
  INCOME_FREQUENCY,
  YEAR_TEXT,
  YEAR_COUPLE,
} from 'Common/constants/incomeTax';
import { getParsed } from 'Common/utilities/math';
import { calculatePay } from 'Common/utilities/incomeCalculator';

export default class IncomeCalculatorCtrl {
  constructor(formattingService, configService, generalService) {
    'ngInject';

    this.formattingService = formattingService;
    this.configService = configService;
    this.generalService = generalService;
  }

  $onInit() {
    this.calculationObject = {
      taxableIncome: '0',
      taxYear: YEAR_TEXT[YEAR_COUPLE.TWENTY_ONE],
      superannuationRate: 9.5,
      frequency: 'ANNUALLY',
      hoursPerWeek: 0,
      weeksPerYear: 0,
      hoursPerDay: 0,
      daysPerYear: 0,
      daysPerWeek: 0,
      withholdTaxOffset: 0,
    };
    this.taxYearOptions = [];
    this.taxData = {};
    this.selectedYear = 0;
    this.getLoanToolsTaxYear();

    this.showIncomeCalculator = this.configService.feature.incomeCalculator;
    this.formatToCurrency = this.formattingService.calculatorFormatCurrency;
    this.incomeFrequency = Object.keys(INCOME_FREQUENCY);

    // calculation variables may vary per year
    this.taxBreakdownRowItems = [
      {
        key: 'pay',
        label: 'Pay',
      },
      {
        key: 'taxableIncome',
        label: 'Taxable Income',
      },
      {
        key: 'superannuation',
        label: 'Superannuation',
      },
      {
        key: 'totalTaxes',
        label: 'Total Taxes',
      },
      {
        key: 'incomeTax',
        label: 'Income Tax',
      },
      {
        key: 'hecsHelpRepayment',
        label: 'HECS/HELP Repayment',
      },
      {
        key: 'medicare',
        label: 'Medicare',
      },
      {
        key: 'taxOffset',
        label: 'Tax Offsets',
      },
    ];

    this.taxItemsKeys = [
      'incomeTax',
      'hecsHelpRepayment',
      'medicare',
      'otherTaxesLevies',
      'taxOffset',
    ];

    this.frequencyOptions = [
      {
        value: 'ANNUALLY',
        label: 'A',
      },
      {
        value: 'MONTHLY',
        label: 'M',
      },
      {
        value: 'FORTNIGHTLY',
        label: 'F',
      },
      {
        value: 'WEEKLY',
        label: 'W',
      },
      {
        value: 'DAILY',
        label: 'D',
      },
      {
        value: 'HOURLY/WEEK',
        label: 'HW',
      },
      {
        value: 'HOURLY/DAY',
        label: 'HD',
      },
    ];
  }

  updateTaxYear(prop, value) {
    this.calculationObject[prop] = YEAR_TEXT[value];
    this.taxData = { ...INCOME_TAX[this.calculationObject.taxYear] };
  }

  updateTaxableIncome(prop, value) {
    if (value) {
      this.calculationObject[prop] = value;
    }
  }

  updateProp(prop, value) {
    this.calculationObject[prop] = value;
  }

  getIncomeCalculationTable() {
    if (
      this.calculationObject.taxableIncome === undefined ||
      Number.isNaN(getParsed(this.calculationObject.taxableIncome))
    ) {
      return;
    }

    this.showHecsHelpRow = this.calculationObject.includeHecsHelp;

    this.incomeCalculationTable = {
      weekly: calculatePay(this.calculationObject, 'WEEKLY'),
      fortnightly: calculatePay(this.calculationObject, 'FORTNIGHTLY'),
      monthly: calculatePay(this.calculationObject, 'MONTHLY'),
      annually: calculatePay(this.calculationObject, 'ANNUALLY'),
    };
  }

  getLoanToolsTaxYear() {
    this.generalService.getLoanToolsTaxYear().then((data) => {
      this.taxYearOptions = data;
      const [defaultOptions] = data ?? [];
      this.calculationObject.taxYear = defaultOptions?.taxYear;
      this.calculationObject.superannuationRate =
        defaultOptions?.superAnnuationDefaultPercentage;
      this.selectedYear = defaultOptions?.taxYearId;
      this.taxData = { ...INCOME_TAX[this.calculationObject.taxYear] };
    });
  }

  updateTaxYearOptions(taxYearId) {
    const { taxYear, superAnnuationDefaultPercentage } =
      this.taxYearOptions.find((option) => option.taxYearId === taxYearId) ??
      {};
    this.calculationObject.superannuationRate = superAnnuationDefaultPercentage;
    this.calculationObject.taxYear = taxYear;
    this.taxData = { ...INCOME_TAX[this.calculationObject.taxYear] };
  }
}
